export default "__VITE_ASSET__Buk85RHu__"